(ns practitest.frontend.forms3.run
  (:require
    [clojure.string :as str]
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.common-entities.metadata :as metadata]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.keyboard-shortcuts :as keyboard-shortcuts]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.common.re-frame :refer [partial-dispatch]]
    [practitest.frontend.components.modal :as modal]
    [practitest.frontend.components.overflow :as overflow]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.components2.run-status :as run-status]
    [practitest.frontend.events :as events]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.collab-ws :as collab-ws]
    [practitest.frontend.forms3.entity-form.forms :as f3.forms]
    [practitest.frontend.forms3.run.events :as run-events]
    [practitest.frontend.forms3.run.navigation :as run-navigation]
    [practitest.frontend.forms3.run.subs :as run-subs]
    [practitest.frontend.forms3.run.timer :as run-timer]
    [practitest.frontend.forms3.run.run-details :as run-details]
    [practitest.frontend.forms3.run.steps :as run-steps]
    [practitest.frontend.forms3.run.mandatory-fields :as mandatory-fields]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(def ^:private entity-type :run)
(def ^:private metadata (get metadata/entities-metadata entity-type))
(def ^:private form-id (get metadata :form-id))
(def ^:private edit-permission (get metadata :edit-permissions))

(defn- form-layout-run [entity-fields]
  (let [nil-or-unavailable? (fn [field]
                              (or (nil? field)
                                  (not (contains? entity-fields field))))
        initial-layout {:title {:fields [{:field :name}]}}
        existing-fields (set (f3.forms/flatten-layout initial-layout))
        to-remove? (fn [field]
                     (or (nil-or-unavailable? field)
                         (contains? existing-fields field)))
        filtered-entity-fields (f3.entity-form/filter-entity-fields entity-fields to-remove?)
        filtered-entity-fields-flat (vec (keys filtered-entity-fields))
        entity-sections @(re-frame/subscribe [::subs/entity-sections entity-type])
        update-main-sections (if (some? entity-sections)
                               #(f3.entity-form/update-layout % entity-sections filtered-entity-fields)
                               #(f3.entity-form/update-layout % (:general-info f3.entity-form/sections-keys) filtered-entity-fields-flat "general_info" entity-fields))
        layout (-> initial-layout (update-main-sections))]
    layout))

(defmethod f3.forms/build-entity-form-layout form-id
  [_ _ _ entity-fields _]
  (form-layout-run entity-fields))

(defn build-edit-controller []
  {:start (fn [params]
            (let [{:keys [run-id project-id]} (:path params)]
              (re-frame/dispatch [::forms/reset-form-state false entity-type form-id []])
              (re-frame/dispatch [::events/set-current-entity-type entity-type])
              (re-frame/dispatch [::subs/set-current-entity-id entity-type run-id])
              (let [fetch-options {:form-id     form-id
                                   :entity-type entity-type
                                   :entity-id   run-id
                                   :project-id  project-id
                                   :new?        false
                                   :got-entity-data [::run-events/got-run]}]
                (re-frame/dispatch [::f3.entity-form/fetch-fields fetch-options])
                (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])
                (re-frame/dispatch [::collab-ws/subscribe-to-form-ws [(:plural-key metadata)]]))
              (re-frame/dispatch [::run-events/fetch-duration run-id])
              (re-frame/dispatch [::run-events/fetch-steps run-id])
              (re-frame/dispatch [::events/fetch-attachments])
              (re-frame/dispatch [::events/fetch-history])
              (re-frame/dispatch [::common-events/trigger-online-request])
              (mixpanel/track "Grid Actions" {"Action" "Edit Run"})))
   :stop (fn [_params]
           (re-frame/dispatch [::run-events/stop-timer])
           (re-frame/dispatch [::events/clear-current-entity entity-type])
           (re-frame/dispatch [::collab-ws/unsubscribe-form-ws [(:plural-key metadata)]])
           (re-frame/dispatch [::forms/reset-form-state false entity-type form-id []]))
   :identity :parameters})

(defn- unsynced-warning-modal [run-id]
  (let [{:keys [show?]} @(re-frame/subscribe [::run-subs/unsynced-warning])]
    [modal/bootstrap-modal
     {:is-open?         (boolean show?)
      :on-request-close (fn []
                          (mixpanel/track "Run Form Actions" {"Action" "Unsaved Changes Cancelled"})
                          (re-frame/dispatch [::run-events/hide-unsynced-warning]))
      :close-button?    true
      :centered?        true
      :class            "run-unsynced-warning-modal"}
     (get-translation "run.nav-guard.title" "Unsynced Changes")
     [:p (get-translation "run.nav-guard.body"
                          "You have done changes to steps during the run. Would you like to update the original test with the same changes before leaving ?")]
     [:<>
      [buttons/button
       {:size     "large"
        :on-click (fn []
                    (mixpanel/track "Run Form Actions" {"Action" "Unsaved Changes Left Without Save"})
                    (re-frame/dispatch [::run-events/confirm-navigate]))
        :text     (get-translation "generic.button.continue" "Continue")}]
      [buttons/button
       {:primary? true
        :size     "large"
        :on-click (fn []
                    (mixpanel/track "Run Form Actions" {"Action" "Unsaved Changes Synced"})
                    (re-frame/dispatch [::run-events/flush-then-sync run-id]))
        :text     (get-translation "run.nav-guard.update-and-continue" "Update and Continue")}]]]))

(defn- general-tab [form-props]
  [:div.run-general-tab
   [run-details/run-details-card form-id form-props]
   [run-steps/run-steps-section form-props]])

(defn build-tabs []
  [{:tab-id    :general
    :tab-title (get-translation "entity.tab.general" "General")
    :tab-view  general-tab}
   (f3.entity-form/history-tab)])

(defn- run-name-field [{:keys [base-entity]}]
  (let [run-name     (:name base-entity)
        created-at   (:created_at base-entity)
        status       (some-> (:status base-entity) str/upper-case)
        status-color (when status (run-status/get-status-color status))]
    [:div.g2-field-container.run-name-container
     [:span.visually-hidden {:id "name-lbl"} (get-translation "generic.fields.name" "Name")]
     [:div.input-with-message-container
      [:div.m-readonly-field
       [overflow/overflow-with-mux-tooltip
        {}
        (fn [props]
          [:span.run-name-text props run-name])
        run-name]
       (when created-at
         [:span.run-name-creation-date
          (str "(" (get-translation "run.creation-date" "Creation Date") ": "
               (fu/formatted-date-time created-at) ")")])]
      (when (and status status-color)
        [:span.run-status-badge
         {:style {:background-color status-color
                  :color            "var(--pt-color-white)"}}
         (run-status/get-status-label status)])]]))

(defn- run-form-shortcuts [{:keys [run-id update-next! next-step-id project-id next-inst editable?]}]
  [:<>
   [keyboard-shortcuts/enable-scope {:shortcuts-type :run-form}]
   [keyboard-shortcuts/add-shortcut {:shortcut [:run-form :pass-all]
                                     :handler  #(when editable? (re-frame/dispatch [::run-events/pass-all run-id]))}]
   [keyboard-shortcuts/add-shortcut {:shortcut [:run-form :pass-next]
                                     :handler  #(when editable? (update-next! "PASSED"))}]
   [keyboard-shortcuts/add-shortcut {:shortcut [:run-form :fail-next]
                                     :handler  #(when editable? (update-next! "FAILED"))}]
   [keyboard-shortcuts/add-shortcut {:shortcut [:run-form :block-next]
                                     :handler  #(when editable? (update-next! "BLOCKED"))}]
   [keyboard-shortcuts/add-shortcut {:shortcut [:run-form :na-next]
                                     :handler  #(when editable? (update-next! "N/A"))}]
   [keyboard-shortcuts/add-shortcut {:shortcut [:run-form :fail-and-issue]
                                     :handler  #(when (and editable? next-step-id)
                                                  (update-next! "FAILED")
                                                  (re-frame/dispatch [::router/push-state :practitest.frontend.issues/new
                                                                      {:project-id project-id}
                                                                      {"from_step_id" next-step-id}]))}]
   [keyboard-shortcuts/add-shortcut {:shortcut [:run-form :run-next-test]
                                     :handler  #(when next-inst
                                                  (re-frame/dispatch [::run-events/safe-navigate-to-instance
                                                                      (:id next-inst)
                                                                      (:testset_id next-inst)]))}]])

(defn main [new?]
  (reagent/with-let [step-editing-sub (re-frame/subscribe [::run-subs/step-editing?])
                     before-unload-fn (fn [e]
                                        (when @step-editing-sub
                                          (.preventDefault e)
                                          (set! (.-returnValue e) ".")))
                     _                (js/window.addEventListener "beforeunload" before-unload-fn)
                     steps-dirty-sub  (re-frame/subscribe [::run-subs/steps-dirty-fields])
                     _                (router/add-dirty-fields! ::run-steps-dirty steps-dirty-sub)
                     mandatory-fields-checked-run-id (atom nil)]
    (let [run             @(re-frame/subscribe [::forms/base-entity entity-type])
          parent-instance @(re-frame/subscribe [::run-subs/parent-instance])
          parent-testset  @(re-frame/subscribe [::run-subs/parent-testset])
          parent-test     @(re-frame/subscribe [::run-subs/parent-test])
          run-id          (:id run)
          missing-mandatory-fields @(re-frame/subscribe [::mandatory-fields/missing-fields])]
      (when (and (seq missing-mandatory-fields)
                 (not= @mandatory-fields-checked-run-id run-id))
        (reset! mandatory-fields-checked-run-id run-id)
        (re-frame/dispatch [::mandatory-fields/show-modal missing-mandatory-fields run-id]))
      (let [next-step        @(re-frame/subscribe [::run-subs/next-undefined-step])
            next-step-id     (:id next-step)
            {:keys [next_instances]} @(re-frame/subscribe [::run-subs/navigation-data])
            next-inst        (first next_instances)
            project-id       @(re-frame/subscribe [::subs/current-project-id])
            edit-locked?     (boolean (:edit_locked parent-test))
            edit-permissions? (permissions/has-permission? edit-permission)
            update-next!     (fn [status]
                               (when next-step-id
                                 (re-frame/dispatch [::run-events/update-step-status next-step-id run-id status])
                                 (dom/scroll-to-next-row! (js/document.getElementById (str "step-run-" next-step-id)))))]
        [:<>
         [run-form-shortcuts {:run-id       run-id
                              :update-next! update-next!
                              :next-step-id next-step-id
                              :project-id   project-id
                              :next-inst    next-inst
                              :editable?    (and edit-permissions? (not edit-locked?))}]
         [unsynced-warning-modal run-id]
         [mandatory-fields/set-mandatory-fields-modal]
         [f3.entity-form/entity-form
        {:new?         new?
         :entity-type  entity-type
         :form-id      form-id
         :on-save      (partial-dispatch [::run-events/save-run run-id])
         :on-cancel    (partial-dispatch [::run-events/reset-run-form new?])
         :entity-fields-optional? true
         :last-breadcrumb-fn
         (fn [_props]
           (if parent-test
             (str (get-translation "run.run-of-test" "Run of Test") " #" (:display_id parent-test))
             (get-translation "generic.loading" "Loading")))
         :entity-name-renderer
         (fn [_form-props]
           (let [pt @(re-frame/subscribe [::run-subs/parent-test])]
             [:span.entity-name
              (if pt
                (str (get-translation "run.run-of-test" "Run of Test") " #" (:display_id pt))
                (get-translation "run.singular" "Run"))]))
         :header-name-fn run-name-field
         :breadcrumbs
         (when (and parent-testset parent-instance parent-test)
           [{:href     (broutes/get-url-view "suites#edit" {:id (:id parent-testset)})
             :label    (str (f3.forms/entity->display-name :testset)
                            " #" (:display_id parent-testset)
                            ": " (:name parent-testset))
             :on-click (fn [e]
                         (.preventDefault e)
                         (mixpanel/track "Run Form Actions" {"Action" "Breadcrumb Test Set Clicked"})
                         (re-frame/dispatch [::run-events/safe-navigate-to-route
                                             ;; reitit route name from routing/routes.cljs (::testset2/edit)
                                             :practitest.frontend.testset2/edit
                                             {:testset-id (:id parent-testset)}]))}
            {:href     (broutes/get-url-view "instances#edit" {:id (:id parent-instance)})
             :label    (str (get-translation "test.instance-of-test" "Instance of Test") " #" (:display_id parent-test)
                            ": " (:name parent-test))
             :on-click (fn [e]
                         (.preventDefault e)
                         (mixpanel/track "Run Form Actions" {"Action" "Breadcrumb Instance Clicked"})
                         (re-frame/dispatch [::run-events/safe-navigate-to-route
                                             ;; reitit route name from routing/routes.cljs (::instance/edit2)
                                             :practitest.frontend.forms3.instance/edit2
                                             {:instance-id (:id parent-instance)}]))}])
         :on-back (fn [_e]
                    (re-frame/dispatch [::run-events/safe-navigate-back]))
         :breadcrumbs-right          (fn [] [run-navigation/run-navigation run-id])
         :buttons-override           run-timer/run-footer
         :header-tabs                (build-tabs)
         :edit-locked?               edit-locked?
         :edit-permissions?          edit-permissions?
         :customization-permissions? (permissions/has-permission? "customization")}]]))
    (finally
      (js/window.removeEventListener "beforeunload" before-unload-fn)
      (router/remove-dirty-fields! ::run-steps-dirty)
      (re-frame/dispatch [::run-events/hide-unsynced-warning])
      (re-frame/dispatch [::run-events/clear-all-step-editing]))))
